import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import TitleIcon from '@mui/icons-material/Title';
import { useCurrentEditor } from '@tiptap/react';
import { HEADINGS } from '@/components/TiptapEditor/Toolbar/data';

const ToolbarHeadingMenu = () => {
	const { editor } = useCurrentEditor();
	const [anchorEl, setAnchorEl] = useState(null);

	const handleSelect = (level) => {
		setAnchorEl(null);
		if (level) {
			editor.chain().focus().setHeading({ level }).run();
		} else {
			editor.chain().focus().setParagraph().run();
		}
	};

	return (
		<>
			<IconButton size='small' onClick={(e) => setAnchorEl(e.currentTarget)}>
				<TitleIcon />
			</IconButton>
			<Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
				<MenuItem dense onClick={() => handleSelect(0)}>
					Normal
				</MenuItem>
				{HEADINGS.map((label, index) => (
					<MenuItem key={label} dense onClick={() => handleSelect(index + 1)}>
						{React.createElement(`h${index + 1}`, { style: { margin: 0 } }, label)}
					</MenuItem>
				))}
			</Menu>
		</>
	);
};

export default ToolbarHeadingMenu;
